/* eslint-disable no-alert */ 
<template>
  <layout :title="$t('exam.title')">
    <div slot="layout-header">
      <button
        v-if="false"
        class="btn btn-secondary large mb-2 dl-pdf-button"
        :disabled="downloadingPdf"
        @click="onClickDownloadPdf"
      >
        <template v-if="!downloadingPdf">{{
          $t("actions.download_pdf")
        }}</template>
        <template v-else>
          <i class="ti ti-refresh ti-spin" />
          {{ $t("actions.downloading_pdf") }}
        </template>
      </button>
    </div>
    <div slot="layout-content">
      <template v-if="!isLoading">
        <template v-if="!_.isEmpty(listExams)">
          <b-container fluid>
            <b-row v-if="$helper.isLegacy && $helper.hasRolePcie" class="mb-2">
              <b-col cols="12" class="mb-1">{{ $t("actions.filter") }}</b-col>
              <b-col v-for="(examFilter, idx) in examFilters" :key="idx" md="4">
                <b-btn
                  :variant="
                    examFilter.player === currentFilter
                      ? 'primary'
                      : 'outline-primary'
                  "
                  block
                  @click="filterResults(examFilter.player)"
                  >{{ examFilter.label }}</b-btn
                >
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="6">
                <b-form-group
                  horizontal
                  :label="$t('exam.search')"
                  class="mb-0"
                >

                
                  <b-input-group>
                    <b-form-input
                      v-model="filter"
                      :placeholder="$t('exam.search')"
                    />
                    <b-input-group-append>
                      <b-btn :disabled="!filter" @click="filter = ''">{{
                        $t("actions.remove")
                      }}</b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
           <!-- ajouter bouton demander son certificat -->
              <b-col md="2">
                <!-- input tests par page reduit + aligné a droite -->
                <b-form-group
                  label-cols-xs
                  horizontal
                  style="transform: translate(240%)"
                  :label="$t('exam.per_page')"
                  class="mb-0 text-right"
                >
                  <b-form-select
                    form-control
                    v-model="perPage"
                    :options="pageOptions"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-table
              :items="$helper.isLegacy ? currentExams : listExams"
              :current-page="currentPage"
              :fields="fields"
              :per-page="perPage"
              :filter="filter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :empty-filtered-text="$t('exam.search_empty')"
              :sort-compare="sortCompare"
              show-empty
              stacked="lg"
              @filtered="onFiltered"
            >
              <template v-slot:cell(showOnVerifPcie)="row">
                <b-form-checkbox
                  v-b-tooltip.hover
                  title="Afficher / Ne pas afficher les tests passés sur le certificat"
                  v-if="row.item.kind !== 'eval'"
                  :id="`checkbox-${row.item.id}`"
                  v-model="row.item.display"
                  @change="toggleVerifPcie(row.item.id)"
                  switch
                />
                <!--rajouté switch bouton-->
              </template>
              <template v-slot:cell(valid)="row">
                <i
                  v-if="row.item.kind !== get().enums.player.eval"
                  :class="`ti ti-fw ti-2x ${isValid(row.value)}`"
                />
                <span v-else>EVAL</span>
              </template>
              <template v-slot:cell(share)="row">
                <div class="d-flex">
                  <a
                    href="#"
                    @click="selectExam(row.item)"
                    v-b-modal="'modal-rs'"
                  >
                    <icon name="share-alt" />
                  </a>
                </div>
              </template>
            </b-table>
            <share
              :testLabel="selectedExamLabel"
              :examId="selectedExamId"
              :score="selectedExamScore"
            />
            <b-row>
              <b-col md="4" class="my-1">
                <!-- a reduire -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </b-container>
        </template>
        <b-alert v-else variant="info" class="m-3" show>{{
          $t("exam.empty_set")
        }}</b-alert>
      </template>
      <loader-text v-else ref="hello" title="dashboard.loading" />
    </div>
  </layout>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies */
import "vue-awesome/icons/brands/twitter";
import "vue-awesome/icons/brands/facebook-f";
import "vue-awesome/icons/share-alt";
/* eslint-disable import/no-extraneous-dependencies */
import LoadOnNavigate from "@/mixins/load-on-navigate";
import Layout from "@/views/Layout";
import LoaderText from "@/components/loader-text";
import Share from "@/components/share";

export default {
  name: "CompletedTestView",
  components: {
    Layout,
    LoaderText,
    Share,
  },
  mixins: [LoadOnNavigate],
  data() {
    return {
      fields: [
        {
          key: "showOnVerifPcie",
          label: this.$t("exam.show_on_verif_pcie"),
          tdClass: "align-middle",
        },
        {
          key: "valid",
          label: "",
          tdClass: "align-middle text-center",
          sortable: this.$helper.showValidatedResult,
        },
        {
          key: "test.label",
          label: this.$t("exam.test"),
          tdClass: "align-middle",
          sortable: true,
        },
        {
          key: "module_label",
          label: this.$t("exam.module"),
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "test.language",
          label: this.$t("exam.language"),
          tdClass: "align-middle",
          formatter: (value) => this.$options.filters.formatCountryCode(value),
          sortable: this.$helper.canShowLanguage,
        },
        {
          key: "start_at",
          label: this.$t("exam.date"),
          sortable: true,
          formatter: (value) => this.$helper.formatDate(value),
          tdClass: "align-middle",
        },
        {
          key: "score",
          label: this.$t("exam.score"),
          sortable: true,
          tdClass: "align-middle",
          formatter: (value) => `${value} %`,
        },
        {
          key: "duration",
          label: this.$t("exam.duration"),
          tdClass: "align-middle",
          sortable: true,
        },
        {
          key: "comment",
          label: this.$t("exam.comments"),
          tdClass: "align-middle",
          formatter: (value) => this.$t(`exam.${value}`),
          sortable: true,
        },
        {
          key: "share",
          label: this.$t("exam.share"),
          tdClass: "align-middle",
        },
      ],
      examFilters: [
        {
          label: this.$t("exam.filter.all"),
          player: "all",
        },
        {
          label: this.$t(`exam.filter.${this.get().enums.player.certif}`),
          player: this.get().enums.player.certif,
        },
        {
          label: this.$t(`exam.filter.${this.get().enums.player.eval}`),
          player: this.get().enums.player.eval,
        },
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: null,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      downloadingPdf: false,
      filter: null,
      modulesLabel: {},
      isLoading: true,
      exams: [],
      currentExams: [],
      listExams: [],
      certifExams: [],
      evalExams: [],
      currentFilter: null,
      selectedExam: { score: 0, label: "", id: 0 },
    };
  },
  computed: {
    selectedExamLabel() {
      return this.selectedExam.label;
    },
    selectedExamId() {
      return this.selectedExam.id;
    },
    selectedExamScore() {
      return this.selectedExam.score;
    },
  },
  methods: {
    selectExam(exam) {
      this.selectedExam.score = exam.score;
      this.selectedExam.id = exam.id;
      this.selectedExam.label = exam.test.label;
      this.$bvModal.show("modal-rs");
    },
    sortCompare(itemA, itemB, key) {
      if (key === "module_label") {
        const valueA = this._.get(itemA, "module_position");
        const valueB = this._.get(itemB, "module_position");

        if (valueA < valueB) {
          return -1;
        }
        if (valueA > valueB) {
          return 1;
        }
        return 0;
      }
      return this._.bootstrap.sortCompare(itemA, itemB, key);
    },

    async toggleVerifPcie(id) {
      await this.$ajax.patch(`exams/${id}/toggle`);
    },
    filterResults(player) {
      let list = this.listExams;
      let filter = "all";

      if (player === this.get().enums.player.certif) {
        list = this.certifExams;
        filter = this.get().enums.player.certif;
      } else if (player === this.get().enums.player.eval) {
        list = this.evalExams;
        filter = this.get().enums.player.eval;
      }

      this.currentFilter = filter;
      this.currentExams = list;
      this.totalRows = list.length;
      this.currentPage = 1;
    },
    async load() {
      this.isLoading = true;
      this.$ajax.get("exams/").then((data) => {
        this.$set(this, "exams", data.exams);
        this.$set(this, "modulesLabel", data.modules);
        this.isLoading = false;

        if (!this.$helper.showValidatedResult) {
          this.$delete(
            this.fields,
            this._.findIndex(this.fields, { key: "valid" })
          );
        }

        if (!this.$helper.canShowLanguage) {
          this.$delete(
            this.fields,
            this._.findIndex(this.fields, { key: "test.language" })
          );
        }

        if (!this.$helper.canDisplayOnVerifPcie) {
          this.$delete(
            this.fields,
            this._.findIndex(this.fields, { key: "showOnVerifPcie" })
          );
        }

        this._.forEach(this.exams, (exam) => {
          this.listExams.push({
            ...exam,
            module_label:
              exam.test.module_label || this.modulesLabel[exam.test.id].label,
            module_position:
              exam.test.module_position ||
              this.modulesLabel[exam.test.id].position,
          });
        });
        this.listExams = this.orderList(
          this.listExams,
          ["start_at", "score", "module_position"],
          ["desc", "desc", "desc"]
        );

        if (this.$helper.isLegacy) {
          this.listExams = this.orderList(this.listExams);
          this.certifExams = this.orderList(
            this._.filter(
              this.listExams,
              (exam) => exam.kind === this.get().enums.player.certif
            )
          );
          this.evalExams = this.orderList(
            this._.filter(
              this.listExams,
              (exam) => exam.kind === this.get().enums.player.eval
            )
          );

          this.filterResults("all");
        }
      });
    },
    orderList(list, column = ["module_position"], order = ["asc"]) {
      return this._.orderBy(list, column, order);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    isValid(exam) {
      return exam
        ? "ti-check-circle text-success"
        : "ti-close-circle text-danger";
    },
    onClickDownloadPdf() {
      this.downloadingPdf = true;
      this.$ajax
        .get("pdf/me", null, { responseType: "blob" })
        .then((data) => {
          this.downloadingPdf = false;
          return this.$fs.download(data, "Rapport.pdf", "application/pdf");
        })
        .catch((error) => {
          this.$notify({
            text: error.message,
            type: "error",
          });
          this.downloadingPdf = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/scss/vars";
@import "compass/css3/transform";

.container {
  .btn:not(.btn-outline-*) {
    border-color: transparent;
  }
}

.dl-pdf-button {
  min-width: 220px;
}

.list-exam > div {
  flex: 1;
}

/deep/ th {
  font-size: 14px;
  font-weight: normal;
  color: $primary;
}

@include media-breakpoint-up(lg) {
  /deep/ td {
    max-width: 150px;
  }

  /deep/.layout-container .layout-content {
    @include transform(translateY(-60px) !important);
  }
}
</style>
